export default "__VITE_ASSET__CQB8PsPf__"